import { styled } from "styled-components";

import { useTranslate } from "common/utilities/useTranslate";
import { ConnectingKeyIssueLine } from "domains/topicDetail/components/topicConnectionBanner/ConnectingKeyIssueLine";
import { MapTopic } from "domains/topicDetail/components/topicConnectionBanner/MapTopic";

const TopicIconsContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const StyledTitle = styled.h2`
  font-size: 2rem;
  font-weight: 600;
  margin: 0px;
  color: white;
  margin-bottom: 10px;
`;

type TopicConnectionBannerProps = {
  className?: string;
  imageUrl: string | undefined;
  secondaryImageUrl: string | undefined;
  secondaryTitle: string;
  title: string;
};

export const TopicConnectionBanner = ({
  title,
  secondaryTitle,
  imageUrl,
  secondaryImageUrl,
  className,
}: TopicConnectionBannerProps) => {
  const translate = useTranslate();
  if (!title || !secondaryTitle) {
    return null;
  }

  return (
    <div>
      <StyledTitle>{translate("app.topic.advanced_analytics.banner.title")}</StyledTitle>
      <TopicIconsContainer className={className}>
        <MapTopic title={title} imageUrl={imageUrl} />
        <ConnectingKeyIssueLine />
        <MapTopic title={secondaryTitle} imageUrl={secondaryImageUrl} />
      </TopicIconsContainer>
    </div>
  );
};
